export default "__VITE_ASSET__6c531619__"